import { unifiedServices } from '@/services/unifiedService';
import { isSupabaseMode } from '@/config/dataSource';

export const ConfiguracoesService = {
  getCurrentUser: async () => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.getCurrentUser();
    }
    return {
      id: 0,
      email: '',
      first_name: '',
      last_name: '',
      role: '',
      status: '',
      created_at: new Date(),
      updated_at: new Date(),
    };
  },
  updateCurrentUser: async (data: any) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.updateCurrentUser(data);
    }
    return data;
  },
  updateAvatar: async (file: File) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.updateAvatar(file);
    }
    return { avatar: '' };
  },
  updatePassword: async (data: any) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.updatePassword(data);
    }
    return Promise.resolve();
  },
  terminateSession: async (sessionId: string) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.terminateSession(sessionId);
    }
    return Promise.resolve();
  },
  toggleTwoFactor: async (enabled: boolean) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.toggleTwoFactor(enabled);
    }
    return Promise.resolve();
  },
  updateTenantSettings: async (tenantId: number, settings: any) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.updateTenantSettings(tenantId, settings);
    }
    return settings;
  },
  getTenantSettings: async (tenantId: number) => {
    if (isSupabaseMode()) {
      return await unifiedServices.configuracoes.getTenantSettings(tenantId);
    }
    return null;
  },
};